import { ListItem } from '@mui/material';
import { ReemaThemeV2 } from '../../theme/reema-theme-V2';
import { useState } from 'react';

interface FlexRowListItemProps {
  children: React.ReactNode;
  gap?: number | string;
  isSelected?: boolean;
  onClick?: () => void;
}

export const FlexRowListItem = ({
  children,
  gap = 2,
  isSelected = false,
  onClick,
}: FlexRowListItemProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <ListItem
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: gap,
        padding: 2,
        width: '100%',
        wordWrap: 'none',
        boxSizing: 'border-box',
        borderRadius: ReemaThemeV2.LIGHT_MODE.app.borderRadius.lessRounded,
        backgroundColor: isSelected
          ? ReemaThemeV2.LIGHT_MODE.palette.surfaceContainer.main
          : 'transparent',
        ...(onClick && {
          '&:hover': {
            cursor: 'pointer',
            backgroundColor: ReemaThemeV2.LIGHT_MODE.palette.secondary.main,
            color: 'white',
          },
        }),
      }}
      onClick={onClick}
    >
      {children}
    </ListItem>
  );
};
